export default __webpack_public_path__ + "static/harmonious-carousel-panel2-9b89a0dec8b1f259dffcccd6453b3746fc179e4cc32522ad5f6e62b790d231ca.png";